import GoToFinalizationPageButton from './GoToFinalizationPageButton';

export default GoToFinalizationPageButton;
